import createIcon from '../../createIcon';

/**
 * @component @name ModeEdit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi45OTkwMiAxNy4yNTE1VjIxLjAwMTVINi43NDkwMkwxNy44MDkgOS45NDE1MkwxNC4wNTkgNi4xOTE1MkwyLjk5OTAyIDE3LjI1MTVaTTIwLjcwOSA3LjA0MTUyQzIxLjA5OSA2LjY1MTUyIDIxLjA5OSA2LjAyMTUyIDIwLjcwOSA1LjYzMTUyTDE4LjM2OSAzLjI5MTUyQzE3Ljk3OSAyLjkwMTUyIDE3LjM0OSAyLjkwMTUyIDE2Ljk1OSAzLjI5MTUyTDE1LjEyOSA1LjEyMTUyTDE4Ljg3OSA4Ljg3MTUyTDIwLjcwOSA3LjA0MTUyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModeEdit = createIcon('ModeEdit', [
  [
    'path',
    {
      d: 'M2.99902 17.2515V21.0015H6.74902L17.809 9.94152L14.059 6.19152L2.99902 17.2515ZM20.709 7.04152C21.099 6.65152 21.099 6.02152 20.709 5.63152L18.369 3.29152C17.979 2.90152 17.349 2.90152 16.959 3.29152L15.129 5.12152L18.879 8.87152L20.709 7.04152Z',
      key: '1gt61k',
    },
  ],
]);

export default ModeEdit;
